module.exports = __webpack_public_path__ + "img/1.b1bc2db8.png";